import { TextWithTooltip } from "@/components/shared/tooltip/TextWithTooltip";
import {
  ResolutionStatus,
  isOriginAuthor,
  isResolutionStatus,
} from "../Explore.model";

const resolutionStatusToLabel: Record<ResolutionStatus, string> = {
  RESOLVED: "Resolved",
  NOT_RESOLVED: "Not Resolved",
  EXPECTED_ESCALATION: "Expected Escalation",
  UNEXPECTED_ESCALATION: "Unexpected Escalation",
  SKIPPED: "Skipped",
  ERROR: "Error",
};

const resolutionStatusToIcon: Record<ResolutionStatus, React.ReactNode> = {
  RESOLVED: "🟢",
  NOT_RESOLVED: "⚪️",
  EXPECTED_ESCALATION: "🟡",
  UNEXPECTED_ESCALATION: "🔴",
  SKIPPED: "🟠",
  ERROR: "🔴",
};

export function getResolutionStatusText(value: string): string {
  return isResolutionStatus(value) ? resolutionStatusToLabel[value] : "";
}

export function getResolutionStatusIcon(value: string): React.ReactNode {
  return isResolutionStatus(value) ? resolutionStatusToIcon[value] : <></>;
}

export function ResolutionStatusFormatter({ value }: { value: string }) {
  if (value == null || !isResolutionStatus(value)) {
    return <></>;
  }

  return (
    <>{`${getResolutionStatusIcon(value)} ${getResolutionStatusText(value)}`}</>
  );
}
